/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { isWxoEnabled } from './config';

export const strings = Object.freeze({
  AI_ASSISTANT_BUILDER: 'AI assistant builder',
  WATSONX_ASSISTANT: 'watsonx Assistant'
});

/**
 * Convenience hook which adjusts the product name for different
 * deployment scenarios.
 *
 * Returns the product name as:
 *   - "AI assistant builder" for watsonx Assistant (WXO)
 *   - "watsonx Assistant" for WXA stand-alone
 */
export const getBranding = () => {
  const productName = isWxoEnabled
    ? strings.AI_ASSISTANT_BUILDER
    : strings.WATSONX_ASSISTANT;

  return {
    productName
  };
};
